import { App, Button, Card, Col, Form, Input, Row, Select, Space, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import LayoutHeader from '../../../adminnavigation/layoutHeader';
import { DELETE, GET, POST } from '../../../utils/apicalls';
import { API } from '../../../config/api';
import { useNavigate } from 'react-router-dom';

function CourseOutline() {
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();
    const [form1] = Form.useForm();
    const { notification } = App.useApp();
    const navigate = useNavigate();
    const [allCourseOutline, setallCourseOutline] = useState<any>([]);
    const [allCourseData, setallCourseData] = useState<any>([]);
    const [CourseFilterData, setCourseFilterData] = useState<any>([]);
    const submitHandler = async (values: any) => {
        try {

            let content = values.content.map((item: any) => item.description);

            let obj = {
                courseoutlineTitle: values.courseoutlineTitle,
                Course_id: Number(values.Course_id),
                content: content,

            };

            setIsLoading(true);
            const postRequest = await POST(API.CREATE_COURSE_OUTLINE, obj);

            if (postRequest) {
                notification.success({ message: " created successfully!" });
                form.resetFields();
                fetachallCourseOutline()
            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {
            console.error(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const feacthallCourse = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_ALL_COURSES, {});
            setallCourseData(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        feacthallCourse();
    }, []);
    const fetachallCourseOutline = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_ALL_COURSE_OUTLINES, {});
            setallCourseOutline(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetachallCourseOutline();
    }, []);

    const handleDelete = async (id: any) => {
        try {
            setIsLoading(true);
            const delete_customer_url = `${API.DELETE_COURSE_OUTLINE}${id}`;
            const data: any = await DELETE(delete_customer_url);

            if (data.status) {
                notification.success({ message: " deleted successfully!" });
                fetachallCourseOutline();
            } else {
                notification.error({
                    message: "Something went wrong! Please try again later.",
                });
            }
        } catch (error) {
            console.log(error);
            notification.error({
                message: "Something went wrong! Please try again later.",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const confirmDelete = (id: any) => {
        const confirm = window.confirm(
            "Are you sure you want to delete this review?"
        );
        if (confirm) {
            handleDelete(id);
        }
    };

    const columns = [
        {
            title: "Index",
            dataIndex: "index",
            render: (_: any, __: any, index: number) => index + 1,
        },
        { title: "courseoutlineTitle", dataIndex: "courseoutlineTitle" },
        {
            title: "Course",
            dataIndex: "Course_id",
            key: "category",
            render: (Course_id: number) => {
                const category = allCourseData.find((cat: any) => cat.id === Course_id);
                return category ? category.course_title : 'Unknown';
            }
        },


        {
            title: "Course outline Description",
            dataIndex: "content",
            key: "content",
            render: (descriptions: string[]) => (
                <ul>
                    {descriptions?.map((desc, idx) => (
                        <li key={idx}>{desc}</li>
                    ))}
                </ul>
            )
        },

        {
            title: "Actions",
            key: "actions",
            render: (_: any, record: any) => (
                <Space size="middle">
                    <Button type="link" onClick={() => confirmDelete(record.id)}>Delete</Button>
                    <Button
                        type="link"
                        onClick={() =>
                            navigate(
                                `/Admin/adminCourseOutline/updateCourseOutline/${record.id}`
                            )
                        }
                    >
                        Edit
                    </Button>
                </Space>
            ),
        },
    ];


    const filterCourseData = async (values: any) => {
        try {
            setIsLoading(true);
            const api = API.FILTER_COURSE_OUTLINE;
            const response: any = await POST(api, values);

            if (response?.status && response.data.length > 0) {
                setCourseFilterData(response.data);
            } else {
                setCourseFilterData([]);
                notification.info({
                    message: "No data found for the selected course.",
                });
            }
        } catch (error) {
            console.log(error);
            notification.error({ message: "An error occurred while filtering." });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            <LayoutHeader />
            <h1 className="text-2xl font-bold mb-4 text-center" style={{ textAlign: "center" }}>Course Outline Management</h1>


            <Card className="p-4 shadow-md rounded-md">
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={submitHandler}
                    className="flex flex-wrap gap-4"
                >
                    <Row gutter={16}>
                        {/* Course Title */}
                        <Col span={8}>
                            <Form.Item
                                label="Course outline Title"
                                name="courseoutlineTitle"
                                rules={[{ required: true, message: 'Please input the course  outline title!' }]}
                            >
                                <Input placeholder="Enter course outline title" />
                            </Form.Item>
                        </Col>



                        <Col span={8}>
                            <Form.Item
                                label="Course"
                                name="Course_id"
                                rules={[{ required: true, message: 'Please select a Course!' }]}
                            >
                                <Select placeholder="Select a Course">
                                    {allCourseData.map((Course: { id: number; course_title: string }) => (
                                        <Select.Option key={Course.id} value={Course.id}>
                                            {Course.course_title}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                label="Course outline Description"
                                name="content"
                                rules={[{ required: true, message: 'Please input at least one description!' }]}
                            >
                                <Form.List
                                    name="content"
                                    initialValue={[]}
                                    rules={[
                                        {
                                            validator: async (_, names) => {
                                                if (!names || names.length < 1) {
                                                    return Promise.reject(new Error('At least one description is required'));
                                                }
                                            },
                                        },
                                    ]}
                                >
                                    {(fields, { add, remove }) => (
                                        <>
                                            {fields.map(({ key, name, fieldKey, ...restField }) => (
                                                <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                                                    <Form.Item
                                                        {...restField}
                                                        name={[name, 'description']}
                                                        rules={[
                                                            { required: true, message: 'Please input a description!' },
                                                            { type: 'string', message: 'Each description must be a string!' },
                                                        ]}
                                                    >
                                                        <Input placeholder="Enter description" />
                                                    </Form.Item>
                                                    <Button onClick={() => remove(name)} icon="-">
                                                        Remove
                                                    </Button>
                                                </Space>
                                            ))}
                                            <Form.Item>
                                                <Button type="dashed" onClick={() => add()} icon="+">
                                                    Add Description
                                                </Button>
                                            </Form.Item>
                                        </>
                                    )}
                                </Form.List>
                            </Form.Item>
                        </Col>


                        <Form.Item>
                            <Button type="primary" htmlType="submit" loading={isLoading}>
                                {isLoading ? 'Creating...' : 'Create'}
                            </Button>
                        </Form.Item>
                    </Row>

                </Form>
            </Card>
            <Card>
                <h2 className="text-center mt-4">Course Outline List</h2>
                <Card className="mb-4">
                    <Form
                        form={form1}
                        layout="inline"
                        onFinish={filterCourseData}
                        style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
                    >
                        <Form.Item
                            label="Course"
                            name="Course_id"
                        // rules={[{ required: true, message: 'Please select a Course!' }]}
                        >
                            <Select placeholder="Select a Course" allowClear>
                                {allCourseData.map((Course: { id: number; course_title: string }) => (
                                    <Select.Option key={Course.id} value={Course.id}>
                                        {Course.course_title}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                Filter
                            </Button>
                            <Button
                                style={{ marginLeft: 8 }}
                                onClick={() => {
                                    form.resetFields();
                                    setCourseFilterData([]); // Clear filtered data
                                    feacthallCourse();
                                }}
                            >
                                Reset
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
                <Table
                    columns={columns}
                    // dataSource={allCourseOutline}
                    dataSource={CourseFilterData.length ? CourseFilterData : allCourseOutline}
                    loading={isLoading}
                    pagination={{ pageSize: 5 }}
                    scroll={{ x: "max-content" }}
                />
            </Card>

        </div>
    );
}

export default CourseOutline
